import axios from "axios";
import { Auth } from "aws-amplify";

const instance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    try {
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      config.headers.Authorization = `Bearer ${accessToken}`;
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        const isAuthenticated = await Auth.currentAuthenticatedUser();
        if (isAuthenticated) {
          await Auth.signOut();
        }
        if (window.location.pathname !== "/login") {
          setTimeout(() => {
            window.location = "/login";
          }, 1000);
        }
      } catch (authError) {
        console.error("Auth error:", authError);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
